<template>
  <div id="CustomerSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">SMS医療機関選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>医療機関コード</th><td><input type="text" v-model="hospitalCode"/></td>
              <th>医療機関名称</th><td><input type="text" v-model="hospitalName"/></td>
              <th>営業所</th>
              <td>
                <select v-model="salesOfficeCode">
                  <option v-for="salesOffice in salesOfficeList" :value="salesOffice.code" :key="salesOffice.code">{{ salesOffice.name }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="code" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="code" label="医療機関コード" width="100" centered>{{props.row.code }}</b-table-column>
              <b-table-column field="name" label="医療機関名称" width="300" >{{props.row.name}}</b-table-column>
              <b-table-column field="phoneNumber" label="電話番号" width="100" >{{props.row.phoneNumber}}</b-table-column>
              <b-table-column field="postCode" label="郵便番号" width="70" >{{props.row.postCode}}</b-table-column>
              <b-table-column field="address" label="住所" width="400" >{{props.row.address}}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  role,
} from "@/components/mock/base/const.js";

export default {
  name: "CustomerSelectModal",
  props: {
    allowBlank:{type:Boolean, default: false, },
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    doSearch: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.smsInspectionReport.getSmsHospitalListPOST({
            body:{
              hospitalCode:  _this.hospitalCode,
              hospitalName:  _this.hospitalName,
              salesOfficeCode: _this.salesOfficeCode,
            }
          });
        },
        async function(result){
          if(_this.allowBlank){
            result.obj.unshift({
              code: "",
              name: "",
              phoneNumber: "",
              postCode: "",
              address: "",
            });
          }
          if(result.obj.length < 1){
            _this.showMessage('該当するSMSの医療機関は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
  },
  data() {
    let salesOfficeList = this.getSalesOfficeMaster();
    const userInfo = this.getUserInfo();
    let salesOfficeCode = userInfo.salesOfficeCode;
    if (userInfo.roleId == role.role_salesOffice) {
      const salesOffice = salesOfficeList.find((elem) => elem.code == salesOfficeCode);
      if (salesOffice) {
        salesOfficeList = salesOfficeList.filter((elem) => elem.blockCode == salesOffice.blockCode);
      } else {
        salesOfficeList = [];
      }
    }
    salesOfficeList.unshift({});

    return {
      data: [],
      salesOfficeList,
      hospitalCode: "",
      hospitalName: "",
      salesOfficeCode,
      selectedItem:"",
      userInfo,
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if(target){
        return target.name
      }
      return ""
    },
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/SmsHospitalSelectModal.vue